/* This file is autogenerated by @oui/cli */ function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Svg, { Path } from "react-native-svg";
var SvgComponent = function(props) {
    return /*#__PURE__*/ _jsxs(Svg, _object_spread_props(_object_spread({
        width: 18,
        height: 18,
        viewBox: "0 0 18 18",
        fill: "none"
    }, props), {
        children: [
            /*#__PURE__*/ _jsx(Path, {
                d: "M6.1 1c-.34.06-.57.32-.8.52A12.5 12.5 0 0 0 1 11.28c.03 1.25.25 2.45.9 3.54a4.6 4.6 0 0 0 1.82 1.7l.17.1c.37.23.82-.13 1.2.16.33.25.74.21 1.14.21h.04c.47.07.84-.4 1.27-.32.51.1.85-.17 1.24-.35.4-.18.66-.54 1.06-.7.22-.63.7-1.13.91-1.78.46-1.36.46-2.74.37-4.14q-.09-1-.3-2c-.08-.46-.36-.94-.55-1.41a12.5 12.5 0 0 0-3.02-4.43A6 6 0 0 0 6.15 1",
                stroke: "currentColor",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                vectorEffect: "non-scaling-stroke"
            }),
            /*#__PURE__*/ _jsx(Path, {
                d: "M7.95 5.52q.7 3.28.56 6.61c-.04 1.14-.2 2.26-.62 3.33-.15.4-.51.7-.51 1.15",
                stroke: "currentColor",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                vectorEffect: "non-scaling-stroke"
            }),
            /*#__PURE__*/ _jsx(Path, {
                d: "M4.83 3.3c-.02.46-.23.86-.35 1.28a21 21 0 0 0-.63 3.2l-.17 1.45",
                stroke: "currentColor",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                vectorEffect: "non-scaling-stroke"
            }),
            /*#__PURE__*/ _jsx(Path, {
                d: "M3.7 12.86c.1.8.22 1.58.49 2.34.16.47.5.86.55 1.37",
                stroke: "currentColor",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                vectorEffect: "non-scaling-stroke"
            }),
            /*#__PURE__*/ _jsx(Path, {
                d: "M10.62 14.78c.18.34.5.37.83.4a3.5 3.5 0 0 0 2.75-1.03 9 9 0 0 0 2.53-4.55c.43-1.7.33-3.39-.17-5.05-.17-.55-.18-.6-.78-.52a9.3 9.3 0 0 0-5.2 2.3q-.24.22-.55.3",
                stroke: "currentColor",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                vectorEffect: "non-scaling-stroke"
            }),
            /*#__PURE__*/ _jsx(Path, {
                d: "M14.45 9.2a18 18 0 0 1-2.75 4.9 6 6 0 0 1-1.73 1.58c-.24.12-.37.44-.71.36-.42-.09-.8-.24-1.1-.55L8 15.33",
                stroke: "currentColor",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                vectorEffect: "non-scaling-stroke"
            })
        ]
    }));
};
export default SvgComponent;
